import { usePathname } from '@/src/navigation/hooks';
import Footer from './Footer';

export default function ConditionalFooter() {
  const pathname = usePathname();

  // Hide footer on report pages (causes UI jump during loading)
  if (pathname.startsWith('/report/')) {
    return null;
  }

  return <Footer />;
}
